(() => {
  const roots = document.querySelectorAll('[data-lzds]:not([data-lzds-ready])');
  roots.forEach(init);

  function init(root) {
    root.dataset.lzdsReady = 'true';
    const $ = (selector, scope = root) => scope.querySelector(selector);
    const $$ = (selector, scope = root) => Array.from(scope.querySelectorAll(selector));
    const number = (value, fallback = 0) => Number.isFinite(Number(value)) ? Number(value) : fallback;
    const uid = (prefix) => `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`;
    const cleanThemePageChrome = () => {
      const normalise = value => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
      document.querySelectorAll('.breadcrumb,.breadcrumbs,[aria-label="breadcrumb"],[aria-label="Breadcrumb"]').forEach(node => {
        if (!root.contains(node) && normalise(node.textContent).includes('zebra blinds design studio')) node.setAttribute('data-lzds-theme-chrome', 'hidden');
      });
      document.querySelectorAll('main h1,.main-content h1,.page-content h1').forEach(node => {
        if (!root.contains(node) && normalise(node.textContent) === 'zebra blinds design studio') {
          const wrapper = node.closest('.section-header,.page-header,.page-title,.page-width--narrow') || node;
          wrapper.setAttribute('data-lzds-theme-chrome', 'hidden');
        }
      });
    };
    cleanThemePageChrome();
    const config = {
      baseRate: number(root.dataset.baseRate, 160), minArea: number(root.dataset.minArea, 2),
      motorFee: number(root.dataset.motorFee, 330), installFee: number(root.dataset.installFee, 65),
      measureFee: number(root.dataset.measureFee, 90), minWidth: number(root.dataset.minWidth, 350),
      maxWidth: number(root.dataset.maxWidth, 2700), minDrop: number(root.dataset.minDrop, 350),
      maxDrop: number(root.dataset.maxDrop, 2400), variantId: root.dataset.checkoutVariant,
      variantPrice: number(root.dataset.checkoutPrice), addUrl: root.dataset.cartAddUrl,
      cartUrl: root.dataset.cartUrl, cartJsonUrl: root.dataset.cartJsonUrl || '/cart.js',
      cartUpdateUrl: root.dataset.cartUpdateUrl || '/cart/update.js',
      checkoutUrl: root.dataset.checkoutUrl || '/checkout', currency: root.dataset.currency || 'AUD'
    };
    const storageKey = `lux-zebra-design-studio-v1-${root.dataset.sectionId || 'default'}`;
    let colours = [];
    try { colours = JSON.parse($('[data-lzds-colours]').textContent); } catch (error) { colours = []; }
    if (!colours.length) colours = [{ id: 'snow', name: 'Snow', code: 'ZW-01', hex: '#f2f0ea', image: null }];

    const blankState = () => ({
      version: 1, mode: null, stage: 'entry', rooms: [], activeWindowId: null,
      service: 'DIY', checkMeasure: false, perthConfirmed: false, confirmed: false,
      createdAt: new Date().toISOString(), updatedAt: new Date().toISOString()
    });
    let state = blankState();

    const presets = {
      '2bed': [['Living Room', 2], ['Dining Room', 1], ['Master Bedroom', 2], ['Bedroom 2', 1]],
      '3bed': [['Living Room', 2], ['Dining Room', 1], ['Master Bedroom', 2], ['Bedroom 2', 1], ['Bedroom 3', 1]],
      '4bed': [['Living Room', 2], ['Dining Room', 1], ['Master Bedroom', 2], ['Bedroom 2', 1], ['Bedroom 3', 1], ['Bedroom 4', 1]],
      empty: [['Living Room', 1]]
    };

    function createWindow(index) {
      return { id: uid('window'), name: `Window ${index}`, width: '', drop: '', colourId: '', fit: '', operation: 'Manual', control: 'Right', notes: '', complete: false };
    }
    function createRoom(name, quantity = 1) {
      return { id: uid('room'), name, windows: Array.from({ length: quantity }, (_, i) => createWindow(i + 1)) };
    }
    function allWindows() { return state.rooms.flatMap(room => room.windows.map(window => ({ ...window, roomId: room.id, roomName: room.name }))); }
    function getWindow(id = state.activeWindowId) {
      for (const room of state.rooms) {
        const window = room.windows.find(item => item.id === id);
        if (window) return { window, room };
      }
      return null;
    }
    function actualArea(window) { return (number(window.width) / 1000) * (number(window.drop) / 1000); }
    function chargedArea(window) {
      const actual = actualArea(window);
      if (!actual || number(window.width) <= 0 || number(window.drop) <= 0) return 0;
      return Math.max(config.minArea, Math.ceil((actual * 2) - 1e-9) / 2);
    }
    function blindPrice(window) {
      const area = chargedArea(window);
      if (!area) return 0;
      return area * config.baseRate + (window.operation === 'Motorised' ? config.motorFee : 0);
    }
    function completeWindows() { return allWindows().filter(window => window.complete); }
    function projectTotal() {
      const windows = allWindows();
      const blinds = windows.reduce((sum, window) => sum + blindPrice(window), 0);
      const install = state.service === 'Perth installation' ? windows.length * config.installFee : 0;
      return blinds + install + (state.checkMeasure ? config.measureFee : 0);
    }
    function money(value) {
      return new Intl.NumberFormat('en-AU', { style: 'currency', currency: config.currency, maximumFractionDigits: 0 }).format(number(value));
    }
    function escapeHtml(value = '') {
      return String(value).replace(/[&<>'"]/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#039;', '"': '&quot;' }[char]));
    }
    function colourFor(id) { return colours.find(colour => String(colour.id) === String(id)) || colours[0]; }
    function swatchStyle(colour) { return colour.image ? `--swatch:url('${String(colour.image).replace(/'/g, '%27')}')` : `--swatch:${colour.hex || '#e8e3d9'}`; }

    function save() {
      state.updatedAt = new Date().toISOString();
      try { localStorage.setItem(storageKey, JSON.stringify(state)); } catch (error) {}
      $('[data-lzds-restore]').hidden = false;
    }
    function loadSaved() {
      try {
        const parsed = JSON.parse(localStorage.getItem(storageKey));
        if (parsed && parsed.version === 1 && Array.isArray(parsed.rooms)) return parsed;
      } catch (error) {}
      return null;
    }
    function clearSaved() { try { localStorage.removeItem(storageKey); } catch (error) {} }
    function alertMessage(message = '') {
      const box = $('[data-lzds-alert]');
      box.hidden = !message; box.textContent = message;
      if (message) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function setScreen(name) {
      $$('[data-lzds-screen]').forEach(screen => { screen.hidden = screen.dataset.lzdsScreen !== name; });
      $('[data-lzds-mobile-project]').hidden = name !== 'builder';
    }
    function gentlyAlignBuilder() {
      const anchor = $('[data-lzds-progress]');
      if (!anchor) return;
      window.requestAnimationFrame(() => {
        const rect = anchor.getBoundingClientRect();
        const offset = 105;
        const needsAlignment = rect.top < offset - 25 || rect.top > window.innerHeight * .38;
        if (!needsAlignment) return;
        const top = Math.max(0, window.scrollY + rect.top - offset);
        window.scrollTo({ top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
    }
    function animateStage(panel) {
      if (!panel || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      panel.classList.remove('lzds-stage-enter');
      window.requestAnimationFrame(() => {
        panel.classList.add('lzds-stage-enter');
        window.setTimeout(() => panel.classList.remove('lzds-stage-enter'), 620);
      });
    }
    function setStage(stage) {
      state.stage = stage; alertMessage();
      $$('[data-lzds-stage]').forEach(panel => { panel.hidden = panel.dataset.lzdsStage !== stage; });
      const order = ['plan', 'measure', 'design', 'review'];
      const activeIndex = order.indexOf(stage);
      $$('[data-lzds-progress] button').forEach((button, index) => {
        button.classList.toggle('is-active', button.dataset.stage === stage);
        button.classList.toggle('is-complete', index < activeIndex);
        button.hidden = state.mode === 'single' && button.dataset.stage === 'plan';
      });
      if (stage === 'plan') renderPlanner();
      if (stage === 'measure') renderMeasurements();
      if (stage === 'design') renderDesign();
      if (stage === 'review') renderReview();
      renderDashboard(); save();
      animateStage($(`[data-lzds-stage="${stage}"]`));
      gentlyAlignBuilder();
    }
    function start(mode) {
      state = blankState(); state.mode = mode;
      if (mode === 'single') {
        state.rooms = [createRoom('My Window', 1)]; state.activeWindowId = state.rooms[0].windows[0].id;
        setScreen('builder'); setStage('measure');
      } else {
        state.rooms = presets['3bed'].map(([name, qty]) => createRoom(name, qty));
        state.activeWindowId = state.rooms[0].windows[0].id;
        setScreen('builder'); setStage('plan');
      }
    }
    function restore() {
      const saved = loadSaved(); if (!saved) return;
      state = saved; setScreen('builder'); setStage(state.stage === 'entry' ? (state.mode === 'single' ? 'measure' : 'plan') : state.stage);
    }

    function setRoomQuantity(roomId, quantity) {
      const room = state.rooms.find(item => item.id === roomId); if (!room) return;
      const target = Math.max(1, Math.min(20, quantity));
      while (room.windows.length < target) room.windows.push(createWindow(room.windows.length + 1));
      while (room.windows.length > target) room.windows.pop();
      room.windows.forEach((window, index) => { window.name = `Window ${index + 1}`; });
      if (!getWindow()) state.activeWindowId = allWindows()[0]?.id || null;
      renderPlanner(); renderDashboard(); save();
    }
    function renderPlanner() {
      $('[data-lzds-room-list]').innerHTML = state.rooms.map(room => `
        <div class="lzds-room" data-room-id="${room.id}">
          <input type="text" value="${escapeHtml(room.name)}" aria-label="Room name" data-room-name>
          <div class="lzds-quantity"><button type="button" data-room-minus aria-label="Remove window">−</button><b>${room.windows.length}</b><button type="button" data-room-plus aria-label="Add window">+</button></div>
          <button type="button" class="lzds-remove" data-room-remove>Remove room</button>
        </div>`).join('');
    }
    function renderMeasurements() {
      $('[data-lzds-measure-table]').innerHTML = allWindows().map(window => `
        <div class="lzds-measure-row" data-window-id="${window.id}">
          <div class="lzds-measure-row__name"><strong>${escapeHtml(window.roomName)} — ${escapeHtml(window.name)}</strong><small>${window.complete ? 'Configured' : 'Measurement required'}</small></div>
          <label class="lzds-field"><span>Width (mm)</span><input data-measure-width type="number" inputmode="numeric" min="${config.minWidth}" max="${config.maxWidth}" step="1" value="${escapeHtml(window.width)}" placeholder="e.g. 1800"></label>
          <label class="lzds-field"><span>Drop (mm)</span><input data-measure-drop type="number" inputmode="numeric" min="${config.minDrop}" max="${config.maxDrop}" step="1" value="${escapeHtml(window.drop)}" placeholder="e.g. 2100"></label>
          <div class="lzds-measure-price">${window.width && window.drop ? money(blindPrice(window)) : '—'}</div>
        </div>`).join('');
    }
    function validateMeasurements() {
      const errors = [];
      allWindows().forEach(window => {
        if (number(window.width) < config.minWidth || number(window.width) > config.maxWidth || number(window.drop) < config.minDrop || number(window.drop) > config.maxDrop) errors.push(`${window.roomName} — ${window.name}`);
      });
      if (errors.length) { alertMessage(`Please enter valid measurements for: ${errors.slice(0, 4).join(', ')}${errors.length > 4 ? ' and more' : ''}. Width ${config.minWidth}–${config.maxWidth} mm; drop ${config.minDrop}–${config.maxDrop} mm.`); return false; }
      return true;
    }

    function renderColours(window) {
      $('[data-lzds-colour-grid]').innerHTML = colours.map(colour => `<button type="button" class="lzds-colour${String(window.colourId) === String(colour.id) ? ' is-selected' : ''}" data-colour-id="${escapeHtml(colour.id)}"><span class="lzds-colour__visual" style="${swatchStyle(colour)}"></span><strong>${escapeHtml(colour.name)}</strong><small>${escapeHtml(colour.code || '')}</small></button>`).join('');
    }
    function syncDesignInputs(window) {
      $$('input[name="lzds-fit"]').forEach(input => { input.checked = input.value === window.fit; });
      $$('input[name="lzds-operation"]').forEach(input => { input.checked = input.value === window.operation; });
      $$('input[name="lzds-control"]').forEach(input => { input.checked = input.value === window.control; });
      $('[data-lzds-notes]').value = window.notes || '';
      const colour = window.colourId ? colourFor(window.colourId) : null;
      $('[data-lzds-colour-summary]').textContent = colour ? `${colour.name}${colour.code ? ` · ${colour.code}` : ''}` : 'Choose your colour';
      $('[data-lzds-fit-summary]').textContent = window.fit || 'Choose recess or face fit';
      $('[data-lzds-operation-summary]').textContent = `${window.operation || 'Manual'} · ${window.control || 'Right'} side`;
    }
    function renderDesign() {
      let found = getWindow();
      if (!found) { state.activeWindowId = allWindows()[0]?.id; found = getWindow(); }
      if (!found) return;
      const { window, room } = found;
      $('[data-lzds-window-title]').textContent = `${room.name} — ${window.name}`;
      $('[data-lzds-window-status]').textContent = window.complete ? 'Editing completed window' : 'Configure this window';
      $('[data-lzds-window-size]').textContent = `${window.width} × ${window.drop} mm · ${actualArea(window).toFixed(2)} m² actual area`;
      $('[data-lzds-window-price]').textContent = money(blindPrice(window));
      renderColours(window); syncDesignInputs(window); renderPriceExplain(window); renderDashboard();
    }
    function renderPriceExplain(window) {
      const area = actualArea(window), charge = chargedArea(window), fabric = charge * config.baseRate, motor = window.operation === 'Motorised' ? config.motorFee : 0;
      $('[data-lzds-price-explain]').innerHTML = `<b>Live price: ${money(fabric + motor)}</b><br>${area.toFixed(2)} m² actual area → ${charge.toFixed(1)} m² chargeable area × ${money(config.baseRate)}/m² = ${money(fabric)}${motor ? ` + ${money(motor)} motorisation` : ''}.`;
    }
    function validateWindow(window) {
      if (!window.colourId) { alertMessage('Please choose a fabric colour for this window.'); return false; }
      if (!window.fit) { alertMessage('Please choose recess fit or face fit for this window.'); return false; }
      if (!window.operation || !window.control) { alertMessage('Please choose the operation and control side.'); return false; }
      return true;
    }
    function saveWindowAndContinue() {
      const found = getWindow(); if (!found || !validateWindow(found.window)) return;
      found.window.notes = $('[data-lzds-notes]').value.trim(); found.window.complete = true;
      const windows = allWindows(); const index = windows.findIndex(window => window.id === found.window.id);
      const next = windows.slice(index + 1).find(window => !window.complete) || windows.find(window => !window.complete);
      save();
      if (next) { state.activeWindowId = next.id; renderDesign(); animateStage($('[data-lzds-stage="design"]')); gentlyAlignBuilder(); }
      else setStage('review');
    }

    function groupedWindows() {
      return state.rooms.map(room => ({ ...room, windows: room.windows.map(window => ({ ...window, roomName: room.name })) }));
    }
    function renderReview() {
      $('[data-lzds-review]').innerHTML = groupedWindows().map(room => `<div class="lzds-review-room"><h4>${escapeHtml(room.name)}</h4>${room.windows.map(window => {
        const colour = colourFor(window.colourId);
        return `<article class="lzds-review-card"><span class="lzds-review-card__swatch" style="${swatchStyle(colour)}"></span><div><strong>${escapeHtml(window.name)} · ${escapeHtml(colour.name)}</strong><small>${window.width} × ${window.drop} mm · ${chargedArea(window).toFixed(1)} m² chargeable · ${escapeHtml(window.fit)} · ${escapeHtml(window.operation)} · ${escapeHtml(window.control)} side</small>${window.notes ? `<small>Note: ${escapeHtml(window.notes)}</small>` : ''}</div><div class="lzds-review-card__price"><strong>${money(blindPrice(window))}</strong><button type="button" data-review-edit="${window.id}">Edit</button></div></article>`;
      }).join('')}</div>`).join('');
      $$('input[name="lzds-service"]').forEach(input => { input.checked = input.value === state.service; });
      $('[data-lzds-check-measure]').checked = state.checkMeasure;
      $('[data-lzds-perth-checkbox]').checked = state.perthConfirmed;
      $('[data-lzds-confirm]').checked = state.confirmed;
      updatePerthVisibility(); renderDashboard();
    }
    function updatePerthVisibility() {
      const required = state.service === 'Perth installation' || state.checkMeasure;
      $('[data-lzds-perth-confirm]').hidden = !required;
      if (!required) state.perthConfirmed = false;
    }

    function dashboardMarkup() {
      const completed = completeWindows().length, total = allWindows().length;
      return groupedWindows().map(room => `<div class="lzds-dash-room"><strong>${escapeHtml(room.name)}</strong>${room.windows.map(window => `<button type="button" class="lzds-dash-window${window.complete ? ' is-complete' : ''}${window.id === state.activeWindowId ? ' is-active' : ''}" data-dash-window="${window.id}"><i></i><span>${escapeHtml(window.name)}<small>${window.width && window.drop ? `${window.width} × ${window.drop} mm` : 'Not measured'}</small></span><b>${money(blindPrice(window))}</b></button>`).join('')}</div>`).join('');
    }
    function renderDashboard() {
      const windows = allWindows(), completed = completeWindows().length, total = windows.length, found = getWindow();
      $$('[data-lzds-total], [data-lzds-mobile-total], [data-lzds-checkout-total]').forEach(item => { item.textContent = money(projectTotal()); });
      $('[data-lzds-progress-label]').textContent = `${completed} of ${total} complete`;
      $('[data-lzds-progress-bar]').style.width = `${total ? (completed / total) * 100 : 0}%`;
      $('[data-lzds-mobile-status]').textContent = `${completed} of ${total} complete · View project`;
      $('[data-lzds-current]').innerHTML = found ? `<span>Current window</span><strong>${escapeHtml(found.room.name)} — ${escapeHtml(found.window.name)}</strong><span>${found.window.width && found.window.drop ? `${found.window.width} × ${found.window.drop} mm · ${found.window.operation}` : 'Measurements not entered'}</span>` : '<span>No active window</span>';
      $('[data-lzds-window-list]').innerHTML = dashboardMarkup();
      const drawerContent = $('[data-lzds-drawer-content]');
      drawerContent.innerHTML = `<div class="lzds-dashboard"><div class="lzds-dashboard__top"><span>Project total</span><strong>${money(projectTotal())}</strong><small>${completed} of ${total} windows complete</small></div><div class="lzds-dashboard__windows">${dashboardMarkup()}</div><div class="lzds-dashboard__actions"><button type="button" data-lzds-review-project>Review Project</button><button type="button" data-lzds-start-over>Start Over</button></div></div>`;
    }

    function goToWindow(id) {
      const found = getWindow(id); if (!found) return;
      state.activeWindowId = id; setStage('design'); closeDrawer();
    }
    function openDrawer() { $('[data-lzds-drawer]').hidden = false; document.body.style.overflow = 'hidden'; renderDashboard(); }
    function closeDrawer() { $('[data-lzds-drawer]').hidden = true; document.body.style.overflow = ''; }
    function openMeasureModal() { const modal = $('[data-lzds-measure-modal]'); if (modal.showModal) modal.showModal(); else modal.setAttribute('open', ''); }
    function closeMeasureModal() { const modal = $('[data-lzds-measure-modal]'); if (modal.close) modal.close(); else modal.removeAttribute('open'); }
    function canReview() {
      if (!allWindows().length) { alertMessage('Please add at least one window.'); return false; }
      if (!validateMeasurements()) return false;
      const incomplete = allWindows().filter(window => !window.complete);
      if (incomplete.length) { state.activeWindowId = incomplete[0].id; alertMessage(`Please finish ${incomplete[0].roomName} — ${incomplete[0].name} before reviewing the project.`); setStage('design'); return false; }
      return true;
    }

    async function removePreviousZebraStudioLines() {
      const response = await fetch(config.cartJsonUrl, { headers: { 'Accept': 'application/json' } });
      if (!response.ok) throw new Error('The existing cart could not be checked. Please try again.');
      const cart = await response.json();
      const updates = {};
      (cart.items || []).forEach(item => {
        const properties = item.properties || {};
        if (properties['_LUXWORLD Design Studio'] === 'Zebra Blinds' || properties['_LUXWORLD Zebra Studio'] === 'true') updates[item.key] = 0;
      });
      if (!Object.keys(updates).length) return;
      const update = await fetch(config.cartUpdateUrl, {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates })
      });
      if (!update.ok) throw new Error('The previous Zebra Design Studio project could not be replaced. Please try again.');
    }

    async function checkout() {
      if (!canReview()) return;
      const perthRequired = state.service === 'Perth installation' || state.checkMeasure;
      if (!state.confirmed) { alertMessage('Please confirm that you have reviewed the project details.'); return; }
      if (perthRequired && !state.perthConfirmed) { alertMessage('Please confirm the property is within the Perth metropolitan service area.'); return; }
      if (!config.variantId || config.variantPrice !== 100) { alertMessage('Checkout is not ready yet. The dedicated LUXWORLD Design Studio checkout product must be selected and priced at exactly $1.00 in the theme settings.'); return; }
      const button = $('[data-lzds-checkout]'); button.disabled = true; button.firstChild.textContent = 'Adding Project… ';
      const projectId = `ZEBRA-${Date.now().toString(36).toUpperCase()}`;
      const windows = allWindows();
      const items = windows.map((window, index) => {
        const colour = colourFor(window.colourId), fabricPrice = chargedArea(window) * config.baseRate;
        const motor = window.operation === 'Motorised' ? config.motorFee : 0;
        const install = state.service === 'Perth installation' ? config.installFee : 0;
        const measure = index === 0 && state.checkMeasure ? config.measureFee : 0;
        const lineTotal = fabricPrice + motor + install + measure;
        const properties = {
          '_LUXWORLD Design Studio': 'Zebra Blinds',
          '_LUXWORLD Zebra Studio': 'true',
          'Project ID': projectId,
          'Room / Window': `${window.roomName} — ${window.name}`,
          'Finished size': `${window.width} mm W × ${window.drop} mm D`,
          'Zebra fabric': `${colour.name}${colour.code ? ` (${colour.code})` : ''}`,
          'Fitting': window.fit,
          'Operation': window.operation,
          'Control / motor side': window.control,
          '_Service selection': state.service,
          '_Installation': install ? `${money(install)} for this window` : 'Not selected',
          '_Onsite check measure': measure ? `${money(measure)} — Perth only` : (state.checkMeasure ? 'Applied to first project line' : 'Not selected'),
          '_Actual area': `${actualArea(window).toFixed(2)} m²`,
          '_Chargeable area': `${chargedArea(window).toFixed(1)} m²`,
          '_Configured line total': money(lineTotal)
        };
        if (window.notes) properties['Manufacturing notes'] = window.notes;
        return { id: Number(config.variantId), quantity: Math.round(lineTotal), properties };
      });
      try {
        await removePreviousZebraStudioLines();
        const response = await fetch(config.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
        if (!response.ok) { const error = await response.json().catch(() => ({})); throw new Error(error.description || 'The configured project could not be added to cart.'); }
        clearSaved(); window.location.assign(config.checkoutUrl);
      } catch (error) {
        alertMessage(error.message || 'The configured project could not be added to cart. Please try again or contact LUXWORLD.');
        button.disabled = false; button.firstChild.textContent = 'Proceed to Checkout ';
      }
    }

    root.addEventListener('click', event => {
      const target = event.target.closest('button, [data-review-edit]'); if (!target) return;
      if (target.matches('[data-lzds-mode]')) start(target.dataset.lzdsMode);
      else if (target.matches('[data-lzds-restore]')) restore();
      else if (target.matches('[data-preset]')) { state.rooms = presets[target.dataset.preset].map(([name, qty]) => createRoom(name, qty)); state.activeWindowId = allWindows()[0]?.id; $$('[data-preset]').forEach(button => button.classList.toggle('is-selected', button === target)); renderPlanner(); renderDashboard(); save(); }
      else if (target.matches('[data-lzds-add-room]')) { state.rooms.push(createRoom(`Room ${state.rooms.length + 1}`, 1)); renderPlanner(); renderDashboard(); save(); }
      else if (target.matches('[data-room-minus], [data-room-plus]')) { const row = target.closest('[data-room-id]'); const room = state.rooms.find(item => item.id === row.dataset.roomId); setRoomQuantity(room.id, room.windows.length + (target.matches('[data-room-plus]') ? 1 : -1)); }
      else if (target.matches('[data-room-remove]')) { const id = target.closest('[data-room-id]').dataset.roomId; if (state.rooms.length === 1) return alertMessage('A project needs at least one room.'); state.rooms = state.rooms.filter(room => room.id !== id); renderPlanner(); renderDashboard(); save(); }
      else if (target.matches('[data-lzds-plan-next]')) { if (!allWindows().length) return alertMessage('Please add at least one window.'); setStage('measure'); }
      else if (target.matches('[data-lzds-back-plan]')) state.mode === 'whole' ? setStage('plan') : setScreen('entry');
      else if (target.matches('[data-lzds-measure-next]')) { if (validateMeasurements()) { state.activeWindowId = allWindows().find(window => !window.complete)?.id || allWindows()[0]?.id; setStage('design'); } }
      else if (target.matches('[data-lzds-back-measure]')) setStage('measure');
      else if (target.matches('[data-colour-id]')) { const found = getWindow(); found.window.colourId = target.dataset.colourId; found.window.complete = false; renderColours(found.window); syncDesignInputs(found.window); renderDashboard(); save(); }
      else if (target.matches('[data-lzds-save-window]')) saveWindowAndContinue();
      else if (target.matches('[data-review-edit]')) goToWindow(target.dataset.reviewEdit);
      else if (target.matches('[data-dash-window]')) goToWindow(target.dataset.dashWindow);
      else if (target.matches('[data-lzds-review-project]')) { if (canReview()) setStage('review'); }
      else if (target.matches('[data-lzds-review-back]')) { state.activeWindowId = allWindows()[0]?.id; setStage('design'); }
      else if (target.matches('[data-lzds-start-over]')) { if (confirm('Start over and clear this saved Zebra blinds project?')) { clearSaved(); state = blankState(); setScreen('entry'); $('[data-lzds-mobile-project]').hidden = true; closeDrawer(); } }
      else if (target.matches('[data-lzds-mobile-project]')) openDrawer();
      else if (target.matches('[data-lzds-close-drawer]')) closeDrawer();
      else if (target.matches('[data-lzds-measure-help]')) openMeasureModal();
      else if (target.matches('[data-lzds-close-modal]')) closeMeasureModal();
      else if (target.matches('[data-lzds-checkout]')) checkout();
      else if (target.matches('[data-stage]')) { const wanted = target.dataset.stage; if (wanted === 'review') { if (canReview()) setStage('review'); } else if (wanted === 'design') { if (validateMeasurements()) setStage('design'); } else if (wanted === 'measure') setStage('measure'); else if (wanted === 'plan' && state.mode === 'whole') setStage('plan'); }
    });

    root.addEventListener('input', event => {
      if (event.target.matches('[data-room-name]')) { const room = state.rooms.find(item => item.id === event.target.closest('[data-room-id]').dataset.roomId); room.name = event.target.value; renderDashboard(); save(); }
      if (event.target.matches('[data-measure-width], [data-measure-drop]')) {
        const found = getWindow(event.target.closest('[data-window-id]').dataset.windowId); if (!found) return;
        const key = event.target.matches('[data-measure-width]') ? 'width' : 'drop'; found.window[key] = event.target.value; found.window.complete = false;
        const price = event.target.closest('.lzds-measure-row').querySelector('.lzds-measure-price'); price.textContent = found.window.width && found.window.drop ? money(blindPrice(found.window)) : '—'; renderDashboard(); save();
      }
      if (event.target.matches('[data-lzds-notes]')) { const found = getWindow(); if (found) { found.window.notes = event.target.value; save(); } }
    });

    root.addEventListener('change', event => {
      const found = getWindow();
      if (found && event.target.matches('input[name="lzds-fit"]')) { found.window.fit = event.target.value; found.window.complete = false; syncDesignInputs(found.window); renderDashboard(); save(); }
      if (found && event.target.matches('input[name="lzds-operation"]')) { found.window.operation = event.target.value; found.window.complete = false; syncDesignInputs(found.window); $('[data-lzds-window-price]').textContent = money(blindPrice(found.window)); renderPriceExplain(found.window); renderDashboard(); save(); }
      if (found && event.target.matches('input[name="lzds-control"]')) { found.window.control = event.target.value; found.window.complete = false; syncDesignInputs(found.window); renderDashboard(); save(); }
      if (event.target.matches('input[name="lzds-service"]')) { state.service = event.target.value; state.confirmed = false; updatePerthVisibility(); renderDashboard(); save(); }
      if (event.target.matches('[data-lzds-check-measure]')) { state.checkMeasure = event.target.checked; state.confirmed = false; updatePerthVisibility(); renderDashboard(); save(); }
      if (event.target.matches('[data-lzds-perth-checkbox]')) { state.perthConfirmed = event.target.checked; save(); }
      if (event.target.matches('[data-lzds-confirm]')) { state.confirmed = event.target.checked; save(); }
    });

    const saved = loadSaved(); $('[data-lzds-restore]').hidden = !saved; setScreen('entry');
  }
})();
